import React, { useMemo } from 'react'

import Chart from './PoDChart.d3'
import ChartWrapper from '../ChartWrapper'

const PoDChart = ({
  data,
  lineKeys,
  inModal,
  chartId,
  relations,
  setSelection = () => {},
}) => {
  const updateProps = useMemo(
    () => ({
      data,
      lineKeys,
    }),
    [data, lineKeys],
  )

  return (
    <ChartWrapper
      Chart={Chart}
      initProps={{
        data,
        relations,
        setSelection,
        lineKeys,
        inModal,
        chartId,
      }}
      updateProps={updateProps}
      margin={{ BOTTOM: 20, LEFT: 40, TOP: 40 }}
    />
  )
}

export default PoDChart
